import React, { Component } from 'react';
import { Field, FieldArray, change } from 'redux-form';
import InputField from 'components/InputField';
import DateTimeField from 'components/DateTimeField';
import * as validators from 'utils/validators';

class Item extends Component {
    render() {
        let { el, onClick } = this.props;
        return <div className="row">
            <div className="col-md-5">
                <Field
                    disabled={true}
                    className="form-control"
                    name={`${el}.title`}
                    component={InputField}
                    type="text"
                    value={`${el}.title`}
                    validate={[validators.required]}
                />
            </div>
            <div className="col-md-2">
                <Field
                    disabled={true}
                    className="form-control"
                    name={`${el}.sku`}
                    component={InputField}
                    type="text"
                    value={`${el}.sku`}
                />
            </div>
            <div className="col-md-1">
                <Field
                    className="form-control"
                    name={`${el}.quantity`}
                    component={InputField}
                    type="text"
                    value={`${el}.quantity`}
                    validate={[validators.required]}
                />
            </div>
            <div className="col-md-3">
                <Field
                    className="form-control"
                    name={`${el}.price`}
                    component={InputField}
                    type="text"
                    value={`${el}.price`}
                    validate={[validators.required]}
                />

            </div>
            <div className="col-md-1">
                <div className="align-center">
                    <i className="fa fa-times-circle location-panel-remove" onClick={onClick}></i>
                </div>
            </div>
        </div>
    }
}

class ShippingItem extends Component {
    render() {
        let { el, onClick } = this.props;
        return <div className="row">
            <div className="col-md-5">
                <Field
                    disabled={true}
                    className="form-control"
                    name={`${el}.title`}
                    component={InputField}
                    type="text"
                    value={`${el}.title`}
                    validate={[validators.required]}
                />
            </div>
            <div className="col-md-2">
            </div>
            <div className="col-md-1">
                <Field
                    disabled={true}
                    component={InputField}
                    className="form-control"
                    type="text"
                    label={"1"}
                />
            </div>
            <div className="col-md-3">
                <Field
                    className="form-control"
                    name={`${el}.price`}
                    component={InputField}
                    type="text"
                    value={`${el}.price`}
                    validate={[validators.required]}
                />

            </div>
            <div className="col-md-1">
                <div className="align-center">
                    <i className="fa fa-times-circle location-panel-remove" onClick={onClick}></i>
                </div>
            </div>
        </div>
    }
}

class Items extends Component {
    render() {
        let { items, fields } = this.props;
        return (<div>
            {fields.map((el, idx) => {
                return items[idx] && <div key={idx}>
                    <Item item={items[idx]} onClick={() => fields.remove(idx)} el={el}></Item>
                </div>
            })}
        </div>
        );
    }
}

class ShippingItems extends Component {
    render() {
        let { items, fields } = this.props;
        return (<div>
            {fields.map((el, idx) => {
                return items[idx] && <div key={idx}>
                    <ShippingItem item={items[idx]} onClick={() => fields.remove(idx)} el={el}></ShippingItem>
                </div>
            })}
        </div>
        );
    }
}


class InvoiceEditor extends Component {

    getRefund() {
        let { editorValues } = this.props;
        editorValues = editorValues || {};

        let sum = (items) => {
            items = items || [];
            let s = 0;

            for (let i = 0; i < items.length; i++) {
                s += Number(items[i].price) * Number(items[i].quantity || 1)
            }

            return s;
        }

        let s = 0;
        s += sum(editorValues.line_items)
        s += sum(editorValues.shipping_lines)
        let total_discounts = Number(editorValues.total_discounts);
        let total_tax = Number(editorValues.total_tax);

        s -= total_discounts;
        if (!editorValues.taxes_included)
            s += total_tax;

        return s.toFixed(2);
    }

    getCredits() {
        let { initialValues } = this.props;
        let total_price = Number(initialValues.total_price);

        return Number(total_price - this.getRefund()).toFixed(2);
    }

    render() {
        let { initialValues, currentInvoiceDate, isValidDate, editorValues, initialOrder, isUpdate, editStorno } = this.props;

        currentInvoiceDate = currentInvoiceDate || new Date();
        
        editorValues = editorValues || {};
        
        return <div>

            {!editStorno && <div className="row">

            <div className={!editStorno? "col-md-5": "col-md-3"}>
                <label>Invoice Date: </label>
                <Field
                    className="form-control"
                    name="date_created"
                    value="date_created"
                    defaultValue={initialValues.date_created ? new Date(initialValues.date_created) : new Date(currentInvoiceDate)}
                    isValidDate={isValidDate}
                    component={DateTimeField}
                    validate={[validators.required]}
                />
            </div>
            {isUpdate ? <div className={!editStorno? "col-md-7": "col-md-3"}>
                <div className="row">
                    <div className="col-md-6">
                        <label htmlFor="invoice_number">Invoice Number:</label>
                        <Field
                            className="form-control"
                            name="invoice_number"
                            component={InputField}
                            type="number"
                            defaultValue={initialValues.invoice_number}
                            validate={[validators.required]}
                            label="Invoice Number"
                            parse={(val) => parseInt(val, 10)}
                        />
                    </div>
                    <div className="col-md-6">
                        <label>Manual Payment</label>{" "}
                        <Field className="form-control" name="is_paid" component="select">
                            <option value="true">Paid</option>
                            <option value="false">Not Paid</option>
                        </Field>
                    </div>
                </div>

            </div>:  <div className="col-md-3"></div>}
            

            </div>
            }
            {editStorno && <div className="row">

                <div className="col-md-4">
                    {initialValues.has_credit_note && <label>Credit Note Date: </label>}
                    {!initialValues.has_credit_note && <label>Storno Date: </label>}
                    <Field
                        className="form-control"
                        name="date_storno"
                        value="date_storno"
                        defaultValue={initialValues.date_storno ? new Date(initialValues.date_storno) : new Date(currentInvoiceDate)}
                        isValidDate={isValidDate}
                        component={DateTimeField}
                        validate={[validators.required]}
                    />
                </div>
                {isUpdate ? <div className="col-md-3">

                    <label htmlFor="storno_number">{initialValues.has_credit_note ? "Credit Note Number:" : "Storno Number:"} </label>
                    <Field
                        className="form-control"
                        name="storno_number"
                        component={InputField}
                        type="number"
                        defaultValue={initialValues.storno_number}
                        validate={[validators.required]}
                        label="Storno/Credit Note Number"
                        parse={(val) => parseInt(val, 10)}
                    />
                </div>:  <div className="col-md-3"></div>}
               
                <div className="col-md-4">
                    <label>Parent Invoice #: {initialOrder.invoice_number}</label>
                </div>
            </div>}<br />
            {editStorno && <div className="row">
               <div className="col-md-12">
                    <label>Products:</label>
                    <div className="row">
                        <div className="col-md-5">
                            Description
                        </div>
                        <div className="col-md-2">
                            SKU
                        </div>
                        <div className="col-md-1">
                            Qty.
                        </div>
                        <div className="col-md-3">
                            Price

                        </div>
                        <div className="col-md-1">

                        </div>
                    </div>
                    <FieldArray name="line_items" items={editorValues.line_items || initialValues.line_items || []} component={Items} />
                    <FieldArray name="shipping_lines" items={editorValues.shipping_lines || initialValues.shipping_lines || []} component={ShippingItems} />

                    {initialOrder.refund_order && Object.entries(initialOrder.refund_order).length > 0 && <button type="button" onClick={async () => {
                        // Fetch the ORIGINAL Shopify order (before any refunds) to get correct line item quantities
                        let revertedLineItems = [];
                        let revertedShippingLines = [];
                        let revertedDiscounts = 0;

                        try {
                            // Get order ID from the refund_order structure
                            const orderId = initialOrder.refund_order.id || initialOrder.refund_order.order_id || initialOrder.order_id;

                            if (orderId) {
                                // Fetch original order from server
                                const response = await fetch(`/shopify/order/${orderId}`);

                                if (response.ok) {
                                    const originalOrder = await response.json();

                                    // Use the fresh Shopify order data (no refunds applied)
                                    revertedLineItems = originalOrder.line_items.map(item => ({...item}));
                                    revertedShippingLines = originalOrder.shipping_lines.map(item => ({...item}));
                                    revertedDiscounts = originalOrder.total_discounts;
                                } else {
                                    throw new Error('Failed to fetch order from Shopify');
                                }
                            } else {
                                throw new Error('No order ID found');
                            }
                        } catch (error) {
                            console.error('Failed to fetch original order, using fallback:', error);

                            // Fallback: try to reconstruct from stored data
                            // This is a backup in case API fails - look for the deepest valid data
                            if (initialOrder.refund_order.refund_order && initialOrder.refund_order.refund_order.line_items) {
                                revertedLineItems = initialOrder.refund_order.refund_order.line_items.map(item => {
                                    const lineItem = {...item};
                                    if (lineItem.initQuantity && lineItem.initQuantity > 0) {
                                        lineItem.quantity = lineItem.initQuantity;
                                    }
                                    return lineItem;
                                });
                                revertedShippingLines = initialOrder.refund_order.refund_order.shipping_lines || initialOrder.shipping_lines || [];
                                revertedDiscounts = initialOrder.refund_order.refund_order.total_discounts || initialOrder.total_discounts || 0;
                            } else {
                                // Last resort: use whatever we have
                                revertedLineItems = initialOrder.line_items || [];
                                revertedShippingLines = initialOrder.shipping_lines || [];
                                revertedDiscounts = initialOrder.total_discounts || 0;
                            }
                        }

                        // Update the form with original order data
                        this.props.dispatch(change('InvoiceEditor', 'line_items', revertedLineItems, true));
                        this.props.dispatch(change('InvoiceEditor', 'shipping_lines', revertedShippingLines, true));
                        this.props.dispatch(change('InvoiceEditor', 'total_discounts', revertedDiscounts), true);
                    }} className="btn btn-default btn-sm"><i className="fa fa-undo"></i>&nbsp;Revert to initial order</button>
                    }

                </div>

            </div>
            }


        </div>
    }
}

export default InvoiceEditor;


// WEBPACK FOOTER //
// app/components/dashboard/InvoiceEditor.jsx